import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetTeacherNewQuestionQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import { useNewAnswerMutation } from '../../slices/teachers/teacherQuestionsApiSlice';
import { useGetTeacherAnswerByQuestionQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherAnswerDetails = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [tittle, setTittle] = useState('');
    const [description, setDescription] = useState('');

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const { data, isLoading, error } = useGetTeacherNewQuestionQuery(id);

    const { data: answerData, isLoading: answerLoading, error: answerError } = useGetTeacherAnswerByQuestionQuery(id);

    
    useEffect(() => {
        if(answerData?.length > 0) {
            navigate(`/teacheranswertype/${answerData[0]._id}`)
        }
    }, [navigate, answerData])
    
    const [newAnswer, { isLoading: loading,  error: newError }] = useNewAnswerMutation();

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    useEffect(() => {
        setTittle(data?.tittle);
      }, [data?.tittle]);

      const subjectname = data?.subjectname;
      const student = data?.student;
      const subject = data?.subject;
         
    const submitHandler = async (e) => {
        e.preventDefault()
        if (description == '') { toast.error('Please enter a description'); return; } 
        try {
            const res = await newAnswer({ id, tittle, subjectname, description, student, subject }).unwrap();
            const newid = res._id;
            navigate(`/teacheranswertype/${newid}`)
            toast.success('Details Saved');
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }  
    };

  return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br /><br />        
            <div className="container-fluid mt--6">
                <div className="row">
                    <div className="col-xl-8 offset-xl-2 ">  
                        <div className="card-wrapper">
                            <div className="card"> <br />
                                <h2 className="centerTitle tittleColor4 ">
                                    <span className='tittleColor4'>Answer New Question</span>
                                </h2><br />
                                {isLoading ? ( 
                                    <Loader />
                                ) : error ? (
                                    <Message variant='danger'>
                                        {error?.data?.message || error.error}
                                    </Message>
                                ) : (
                                    <div className="card-body">
                                        <Form onSubmit={submitHandler}>
                                            <div className="form-group emailForm2">
                                                <div className="input-group input-group-merge input-group-alternative mb-3">
                                                    <div className="input-group-prepend moveInput">
                                                    <span className="input-group-text bg-gradient-primary"><i className="ni ni-tag navText"></i></span>
                                                    </div>
                                                    <input 
                                                    className="form-control emailForm" 
                                                    placeholder="  Title" 
                                                    type="text" 
                                                    value={tittle}
                                                    disabled
                                                    onChange={(e) => setTittle(e.target.value)}                                              
                                                    />
                                                </div>
                                            </div><br /><br />
                                            <div className="form-group">
                                                <div className="input-group input-group-merge input-group-alternative mb-3">
                                                    <div className="input-group-prepend moveInput">
                                                    <span className="input-group-text bg-gradient-warning"><i className="ni ni-archive-2 navText"></i></span>
                                                    </div>
                                                    <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="  Description" 
                                                    rows="3"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}                                          
                                                    />
                                                </div>
                                            </div>
                                            <div className='mycard'><br /><br /><br /><br />
                                                <Button  type='submit' variant="primary rounded-pill bg-gradient-info btn-lg "> 
                                                    Upload Video 
                                                </Button><br /><br />
                                            </div>
                                        </Form>
                                    </div>
                                )} 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default TeacherAnswerDetails
